(() => {
  if (customElements.get('sf-store-banners')) return;
  customElements.define('sf-store-banners', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-ss-slide]')];
      this.index = 0; this.paused = false; this.hovered = false; this.focused = false; this.visible = true; this.editorSelected = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.count = this.querySelector('[data-ss-count]');
      this.pause = this.querySelector('[data-ss-pause]');
      this.querySelector('[data-ss-controls]')?.removeAttribute('hidden');
      this.querySelector('[data-ss-prev]')?.addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-ss-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
      this.pause?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.pause.setAttribute('aria-pressed', String(this.paused));
        this.pause.textContent = this.paused ? 'Play' : 'Pause';
        this.syncVideo(); this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.ssSlide === event.detail?.blockId);
        if (index >= 0) { this.editorSelected = true; this.show(index); }
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
      this.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' && !event.target.closest('video,a,button')) this.touch = { x: event.clientX, y: event.clientY };
      }, options);
      this.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const x = event.clientX - this.touch.x, y = event.clientY - this.touch.y; this.touch = null;
        if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) this.show(this.index + (x < 0 ? 1 : -1));
      }, options);
      this.addEventListener('pointercancel', () => { this.touch = null; }, options);
      document.addEventListener('visibilitychange', () => { this.syncVideo(); this.schedule(); }, options);
      this.motion.addEventListener('change', () => { this.syncVideo(); this.schedule(); }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.syncVideo(); this.schedule(); }, { threshold: .1 });
      this.observer.observe(this);
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      if (this.count) this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.syncVideo(); this.schedule();
    }
    syncVideo() {
      this.slides.forEach((slide, i) => slide.querySelectorAll('video').forEach(video => {
        if (i !== this.index || document.hidden || !this.visible || this.paused || this.motion.matches) { video.pause(); return; }
        if (this.dataset.autoplay === 'true') { video.muted = true; video.play()?.catch(() => {}); }
      }));
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editorSelected || !this.visible || document.hidden || this.motion.matches) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Math.max(3000, Number(this.dataset.interval) || 6000));
    }
    disconnectedCallback() {
      clearTimeout(this.timer); this.observer?.disconnect(); this.controller?.abort(); this.controller = null;
      this.slides?.forEach(slide => slide.querySelectorAll('video').forEach(video => video.pause()));
    }
  });
})();
